export const videoData = [
    {
        videoUrl: "https://www.youtube.com/embed/z0J5me_KfbA?si=xha7AQ1NurTXl8fP",
        title: "Building better software for science: Lessons from software engineering | BrainHack Vanderbilt 2026",
        personalUrl: "https://profiles.stanford.edu/russell-poldrack"
    },
    {
        videoUrl: "https://www.youtube.com/embed/NwLU547vLT4?si=zfMahK2jiXpNKBZ2",
        title: "How To Measure And Reduce The Carbon Footprint Of Fmri Data Analysis | BrainHack Vanderbilt 2026",
        personalUrl: "https://profiles.sussex.ac.uk/p596400-nick-souter"
    },
    {
        videoUrl: "https://www.youtube.com/embed/8r9rsCLU-0Q?si=Yh4ssQMuLIziTbNJ",
        title: "Sustainability in Scientific Research: Challenges and Opportunities, J. Magnolia Gilligan",
        personalUrl: "https://www.magnoliagilligan.org/"
    },
    {
        videoUrl: "https://www.youtube.com/embed/r3Oq0NpAXf8?si=Fyob3939La_c77qo",
        title: "Joining a World Wide Lab, Alex Maier",
        personalUrl: "https://maierlab.wiki/"
    },
    {
        videoUrl: "https://www.youtube.com/embed/m5ltNkCHv1g?si=BSXr4h79hK6yVYkC",
        title: "Cognitive Neuroscience in the Foundation Model Era: Lessons in Reproducibility, Hao-Ting Wang",
        personalUrl: "https://wanghaoting.com/"
    },
    {
        videoUrl: "https://www.youtube.com/embed/Mh_zPJueUkA?si=6FOltsGovbihf153",
        title: "Exploratory Data Analysis | J. Andres Gannon @ BrainHack Vanderbilt 2025",
        githubUrl: "https://github.com/brainhack-vandy/brainhack-eda"
    },
    {
        videoUrl: "https://www.youtube.com/embed/sa59OLr6FMc?si=FfiwSj4PMRiAPv6w",
        title: "NiiVue Visualization | Chris Rorden @ BrainHack Vanderbilt 2025",
        githubUrl: "https://github.com/brainhack-vandy/traintrack/tree/main/NiiVue"
    },
    {
        videoUrl: "https://www.youtube.com/embed/86r-DtIQulY?si=u_ggtzSFdg3KmoV0",
        title: "Getting Started With Latest ML Approaches: EEG-to-fMRI Translator | Yamin Li @ BrainHack Vanderbilt 2025",
        githubUrl: "https://github.com/brainhack-vandy/how-to-start-latest-ml-approaches"
    },
    {
        videoUrl: "https://www.youtube.com/embed/V2_ILtZjEkQ?si=RMTKKaKpMFiJat4u",
        title: "Opening Ceremony and Keynote Address | BrainHack Vanderbilt 2025",
        personalUrl: "https://dmri.mgh.harvard.edu/a-y/"
    },
    {
        videoUrl: "https://www.youtube.com/embed/bWI6UWrY0gs?si=lzaKcYfMZEf93qJ5",
        title: "Open Science X Neuroscience Panel | BrainHack Vanderbilt 2025",
    },
    {
        videoUrl: "https://www.youtube.com/embed/ojnV7mWlQD8?list=PLYyjtw9w4UUAik7EvdeHKDDmVyBNOxh5s",
        title: "Open Science Best Practices | Remi Gau @ BHVU 2024",
        personalUrl: "https://remi-gau.github.io/"
    },
    {
        videoUrl: "https://www.youtube.com/embed/lwxtkvPb4UA?list=PLYyjtw9w4UUAik7EvdeHKDDmVyBNOxh5s",
        title: "Practical Introduction to Structural and Diffusion MRI | Adam Anderson @ BHVU 2024",
        githubUrl: "https://github.com/brainhack-vandy/practical-introduction-to-structural-and-diffusion-MRI"
    },
    {
        videoUrl: "https://www.youtube.com/embed/pONB6xAO9v0?list=PLYyjtw9w4UUAik7EvdeHKDDmVyBNOxh5s",
        title: "To build a home: 12 years of brainhack | Pierre Bellec @ BHVU 2024",
        personalUrl: "https://www.linkedin.com/in/pierre-lune-bellec-6831b9b/"
    }
];


export const resourceData = [
    {
        imageUrl: "/assets/educationals/neuromatch.io.png",
        title: "Neuromatch Open Education Resources",
        description: "Neuromatch Academy offers a range of educational programs, primarily focused on computational neuroscience, artificial intelligence (AI), and climate science, designed to be accessible and inclusive globally.",
        visitUrl: "https://neuromatch.io/open-education-resources/"
    },
    {
        imageUrl: "/assets/educationals/the-turing-way.org.jpg",
        title: "The Turing Way",
        description: "A handbook for reproducible, ethical and collaborative data science. This community-driven project aims to provide comprehensive guidance to help researchers, data scientists, engineers, and policymakers across sectors create reproducible and reusable projects.",
        visitUrl: "https://book.the-turing-way.org/"
    }
];

export const eventData = [
    {
        imageUrl: "/assets/educationals/reprohack.org.jpeg",
        title: "ReproHack Hub",
        description: "A ReproHack is a collaborative event where participants attempt to reproduce published research from a curated list of papers with publicly available code and data. ",
        visitUrl: "https://www.reprohack.org/"
    },
    {
        imageUrl: "/assets/educationals/brainhack.org.jpeg",
        title: "BrainHack",
        description: "Advancing neuroscience requires large datasets and complex analyses. Brainhack bridges data science and neuroscience communities to drive brain research forward.",
        visitUrl: "https://brainhack.org/"
    }
];

export const labData = [
    {
        imageUrl: "/assets/educationals/neurodatascience.github.io.png",
        title: "ORIGAMI (NeuroDataScience) Lab",
        description: "A group at the Montreal Neurological Institute, the ORIGAMI lab, develops methods and tools to best analyse neuroimaging and genetics data, and strive to produce and foster more reproducible and replicable science.",
        visitUrl: "https://neurodatascience.github.io/research.html"
    }
];